import React from 'react';

const MetricCard = ({ title, value, trendText, subtext, icon, iconBg, borderColor, trend }) => {
  return (
    <div className="relative bg-white rounded-xl shadow-[0_2px_10px_rgba(0,0,0,0.04)] border border-slate-200 p-5 min-h-[120px] flex flex-col justify-center gap-2 overflow-hidden transition-all hover:shadow-[0_4px_12px_rgba(0,0,0,0.08)]">
      <div className="absolute left-0 top-0 bottom-0 w-[5px]" style={{ backgroundColor: borderColor }} />
      <div className="flex items-center gap-2.5 pl-3">
        <div className="w-[26px] h-[26px] rounded flex items-center justify-center text-white text-[15px] font-bold" style={{ backgroundColor: iconBg }}>
          {icon}
        </div>
        <span className="text-[14px] font-bold text-slate-500 uppercase tracking-wider leading-tight">{title}</span>
      </div>
      <div className="text-[26px] font-bold text-slate-800 pl-3 mt-1.5">{value}</div>
      <div className="text-[13px] text-slate-500 flex items-center gap-1.5 pl-3 mt-1">
        {trend === 'up' && <span className="text-green-600 font-bold text-[13px]">▲</span>}
        {trend === 'down' && <span className="text-red-500 font-bold text-[13px]">▼</span>}
        {trendText && (
          <span className={trend === 'up' ? 'text-green-600 font-bold' : trend === 'down' ? 'text-red-500 font-bold' : ''}>
            {trendText}
          </span>
        )}
        <span>{subtext}</span>
      </div>
    </div>
  );
};

export default MetricCard;
